import * as yup from 'yup';
import { SimpleCalloutCards } from '@web/components';
import { linkSchema } from '../schemas';
import { schema as simpleCalloutCardSchema } from './simple_callout_card';

export const component = SimpleCalloutCards;

export const schema = yup
  .object({
    headline: yup.string(),
    eyebrow: yup.string(),
    subheadline: yup.string(),
    cards: yup.array(simpleCalloutCardSchema).required(),
    backgroundColor: yup.string().optional(),
    cta: linkSchema.optional(),
    ctaColor: yup.string(),
    fontColor: yup.string(),
    mobileCardsPerRow: yup.number(),
    desktopCardsPerRow: yup.number(),
    typography: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    eyebrow: value.eyebrow,
    subheadline: value.subheadline,
    cards: value.cards,
    backgroundColor: value.background_color || null,
    cta: value.cta?.[0] || null,
    ctaColor: value.cta_color || undefined,
    fontColor: value.font_color || null,
    mobileCardsPerRow: value.mobileCardsPerRow || undefined,
    desktopCardsPerRow: value.desktopCardsPerRow || undefined,
    typography: value.typography || undefined,
  }));
